import createReactComponent from '../createReactComponent';
export default createReactComponent('clock-hour-9', 'IconClockHour9', [
  ['path', { d: 'M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0', key: 'svg-0' }],
  ['path', { d: 'M12 12h-3.5', key: 'svg-1' }],
  ['path', { d: 'M12 7v5', key: 'svg-2' }],
]);
